module.exports = __webpack_public_path__ + "static/media/the-building.6a1bea21.jpeg";